import {ActionsTypes} from "../consts/actionsTypes";
import {AppDispatch} from "../store";
import {ILoadingComponents} from "../../interfaces/datesGlobalState.interface";

export const setIsLoading = (isLoading: Partial<ILoadingComponents>) => (dispatch: AppDispatch) => {
    dispatch({type: ActionsTypes.SET_IS_LOADING, payload: {isLoading}})
}
